import { CardHistoricoProps } from "../../Base/types";
import CardHistoricoBase from "../../Base/CardHistoricoBase";
import { RotateCcw, LucideIcon } from "lucide-react";
import ExpandedContent from "./ExpandedContent";

const detectaDemandaRetornadaExecucao = (acao: string): boolean => {
    const acaoLower = acao.toLowerCase().trim();
    return acaoLower.includes('demanda retornada para execução') || 
           acaoLower.includes('demanda retornada para execucao') ||
           acaoLower.includes('demanda retornada para contratação') ||
           acaoLower.includes('demanda retornada para contratacao');
};

const getIconDemandaRetornadaExecucao = (acao: string): { Icon: LucideIcon; color: string } => {
    return { Icon: RotateCcw, color: 'var(--cf59e0b)' };
};

export default function CardDemandaRetornadaExecucao({ 
    item, 
    onNavigateToFile, 
    isExpanded, 
    onToggleExpand 
}: CardHistoricoProps) {
    return (
        <CardHistoricoBase
            item={item}
            icon={getIconDemandaRetornadaExecucao(item.acao)}
            temExpansaoDisponivel={true}
            isExpanded={isExpanded}
            onToggleExpand={onToggleExpand}
            expandedContent={
                <ExpandedContent item={item} onNavigateToFile={onNavigateToFile} />
            }
        />
    );
}

export const demandaRetornadaExecucaoConfig = {
    tipo: 'demanda_retornada_execucao',
    detectaTipo: detectaDemandaRetornadaExecucao,
    getIcon: getIconDemandaRetornadaExecucao,
    temExpansao: () => true,
    Component: CardDemandaRetornadaExecucao
};


